import React from "react";
import styled from "styled-components";
import Modal from "react-awesome-modal";
import Loader from "react-loader";
import ScrollBars from "react-custom-scrollbars";


import { PROXIED_MEDIABASE } from "../../../../common/constants";

import { ModalContent, ModalRow, AssetItem } from "../EditModal/Modal.styles";
import Handle from "../Handle/Handle.Component";
import withServices from "../../../../HOCs/withServices";
import AssetCollectionOption from '../../../../components/Admin/LessonBuilder/AssetCollections/AssetCollectionOption';

import { sampleImages } from "../../../../assets/images/lessonbuilder/images";
import { toast } from "react-toastify";

const StyledImgInput = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 200px;
  width: 100%;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 5px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  height: 150px;

  input,
  select,
  img {
    width: 33%;
    margin-right: 4px;
  }
`;

const ImagesContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  overflow-y: scroll;
  width: 100%;
  height: 100%;
  align-content: flex-start;
`;

const Button = styled.button`
  display: ${(props) => (props.show ? "block     " : "none")};
  height: 40px;
  width: 90%;
  border-radius: 5px;
  border: 2px #fff solid;
  background-color: rgba(255, 255, 255, 0.2);
  font: normal normal 22px "Roboto Condensed";
  text-transform: uppercase;
  color: #fff;
`;

class ImageInput extends React.Component {
  state = {
    modalOpen: false,
    showEdit: false,
    imgCollections: null,
    collectionsLoaded: false,
    images: null,
    imagesLoaded: false,
    selectedCollection: null,
    imageKeyword: "",
    collectionsKeyword: ""
  };

  constructor(props) {
    super(props);
    this.chooseImgCollectionHandler = this.chooseImgCollectionHandler.bind(
      this
    );
  }
  async componentDidMount() {
    const {
      services: { adminAPI },
    } = this.props;
    const res = await adminAPI.getAssetCollections();
    if (res.ok) {
        console.log('COllection: ' + JSON.stringify(res.data, null, 2))
      this.setState({ imgCollections: res.data, collectionsLoaded: true });
    }
  }

  toggleEditButtons = () => {
    const { showEdit } = this.state;
    this.setState({ showEdit: !showEdit });
  };

  toggleModal = () => {
    const { modalOpen } = this.state;
    this.setState({ modalOpen: !modalOpen });
  };
  openModal = () => {
    this.setState({ modalOpen: true });
    // query for images
    // const images = sampleImages.images;
    // this.setState({images});
  };
  closeModal = () => {
    this.setState({ modalOpen: false });
  };

  closeModalHandler = (colIdx, value) => {
    this.props.selectImage(colIdx, `${PROXIED_MEDIABASE}assets/${value}`);
    this.setState({ modalOpen: false });
  };

  changeAlign = (event) => {
    // pass columnIndex, property to change, value to change to
    const value = event.target.value;
    this.props.changeStyleProperty(this.props.columnIndex, "align", value);
  };

  changeWidth = (event) => {
    const value = event.target.value;
    this.props.changeStyleProperty(this.props.columnIndex, "size", value);
  };

  deleteAsset = () => {
    this.props.deleteAsset(this.props.columnIndex);
  };
  async chooseImgCollectionHandler(event) {
    this.setState({ imagesLoaded: false, selectedCollection: +event.target.value });
    const res = await this.props.services.adminAPI.getCollectionItems(
      +event.target.value
    );
    if (res.ok) {
      console.log("IMGRes: " + JSON.stringify(res.data, null, 2));
      const images = res.data.assets;
      this.setState({ images, imagesLoaded: true });
    } else {
      toast.error("Images Not Found!");
    }
  }

  onSearchChangeHandler = (field, e) => {
    if(field === 'asset') {
      this.setState({imageKeyword: e.target.value});
    }
    if(field === "collection") {
      this.setState({collectionsKeyword: e.target.value});
    }
  }

  renderCollectionOptions = () => {
    const { collectionsLoaded, imgCollections,selectedCollection, collectionsKeyword } = this.state;
    if (collectionsLoaded) {
      const filteredCollections = imgCollections.filter(item => {
        if (collectionsKeyword === "") {
          return item
        } else {
          return item.Name.toLowerCase().includes(collectionsKeyword.toLowerCase())
        }
      })
      return (
          <React.Fragment>
              {/* <p style={{ color: "white" }}>Choose A Collection Here!</p> */}
          <input
            type="text"
            className="custom-textfield"
            placeholder="Search Collection Name"
            value={collectionsKeyword}
            onChange={this.onSearchChangeHandler.bind(this, 'collection')}
          />
              <ScrollBars style={{height:"70vh"}} className="hide-x">
                {filteredCollections.map(collection => {
                    return (
                        <AssetCollectionOption 
                            collectionID = {collection.AssetCollectionId}
                            selectedCollection = {selectedCollection}
                            collectionName = {collection.Name}
                            collectionDescription = {collection.Description}
                            onCollectionChange = {this.chooseImgCollectionHandler}                       
                        />
                    )
                })}
              </ScrollBars>
          </React.Fragment>
        
      );
    } else {
      return <Loader color="#acff2430" />;
    }
  };

  renderImagesContainer = () => {
    const { images, imagesLoaded, imageKeyword } = this.state;
    if (imagesLoaded) {
      const filteredImages = images.filter(item => {
        if(imageKeyword === "") {
          return item
        }else {
          return item.Title.toLowerCase().includes(imageKeyword.toLowerCase())
        }
      })
      return (
        <React.Fragment>
          {/* <p style={{ color: "white" }}>Choose An Image Here!</p> */}
          <input
          style={{width: "75%"}}
            type="text"
            className="custom-textfield"
            placeholder="Search Asset Name"
            value={this.state.imageKeyword}
            onChange={this.onSearchChangeHandler.bind(this, 'asset')}
          />
          <ImagesContainer>
            {filteredImages.map((img, idx) => {
              return (
                  <AssetItem border={true}>
                      <img
                  key={idx}
                  src={`${PROXIED_MEDIABASE}assets/${img.FileName}`}
                  onClick={this.closeModalHandler.bind(
                    this,
                    this.props.columnIndex,
                    img.FileName
                  )}
                />
                <p className="col-asset-name">{img.Title}</p>
                  </AssetItem>                
              );
            })}
          </ImagesContainer>
        </React.Fragment>
      );
    } else {
      return (
        <ImagesContainer>
           <p style={{ color: "#fff", font: "italic bold 26px 'Roboto", marginTop: "35%", textAlign: "center" }}>
          Please choose an Image Collection First
        </p>
        </ImagesContainer>
       
      );
    }
  };

  render() {
    return (
      <StyledImgInput>
        <Modal
          visible={this.state.modalOpen}
          width="90%"
          height="85%"
          effect="fadeInUp"
          onClickAway={() => this.closeModal()}
        >
          <ModalContent>
            <ModalRow>
              <div className="modal-left">{this.renderCollectionOptions()}</div>
              <div className="modal-right">{this.renderImagesContainer()}</div>
            </ModalRow>
          </ModalContent>
        </Modal>
        <Handle type={this.props.type} deleteAsset={this.deleteAsset} />
        <ContentWrapper>
          <input
            className="custom-textfield lb-textfield"
            type="number"
            name="width"
            id="width"
            placeholder={this.props.size}
            onChange={this.changeWidth}
          />
          <select
            className="custom-textfield lb-select"
            name=""
            id=""
            onChange={this.changeAlign}
          >
            <option selected={this.props.alignment === "center"} value="center">
              Center
            </option>
            <option selected={this.props.alignment === "left"} value="left">
              Left
            </option>
            <option selected={this.props.alignment === "right"} value="right">
              Right
            </option>
          </select>
          <div
            onMouseEnter={this.toggleEditButtons}
            onMouseLeave={this.toggleEditButtons}
          >
            <img
              style={{ width: "60px", height: "auto" }}
              src={this.props.url}
              alt="Add Image"
            />
            <Button show={this.state.showEdit} onClick={this.openModal}>
              Edit
            </Button>
          </div>
        </ContentWrapper>
      </StyledImgInput>
    );
  }
}

export default withServices(ImageInput);



// WEBPACK FOOTER //
// ./src/components/Admin/LessonBuilder/ImageInput/ImageInput.Component.jsx